<template>
    <div class="row left-content">
        <b-card
            v-if="wallets"
            title="Projects Wallets"
        >
            <table class="table table-bordered table-striped mt-4">
                <thead>
                <tr>
                    <th>ID</th>
                    <th>Project</th>
                    <th>Created At</th>
                    <th>Name</th>
                    <th>Type</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="wallet in wallets" :key="wallet.id">
                    <td>
                        <router-link :to="{name: 'admin.wallet.wallet_project.view', params: { id: wallet.id }}">
                            {{ wallet.id }}
                        </router-link>
                    </td>
                    <td>{{ wallet.project_title }}</td>
                    <td>{{ formatedDate(wallet.date) }}</td>
                    <td>{{ wallet.name + '(' + wallet.email + ')' }}</td>
                    <td>
                        <b-badge class="mr-1" variant="primary" v-if="wallet.payment_customer_id">Demand</b-badge>
                        <b-badge variant="success" v-if="wallet.transfer_customer_id">Supplier</b-badge>
                    </td>
                </tr>
                </tbody>
            </table>
            <b-pagination
                v-if="paginator.total / paginator.perPage > 1"
                :value="page"
                :total-rows="paginator.total"
                :per-page="paginator.perPage"
                @change="change($event)"
            ></b-pagination>
        </b-card>

    </div>
</template>

<script>
export default {
    name: "List",
    props: {
        'page': {
            'default': 1
        }
    },
    data() {
        return {
            wallets: [],
            paginator: [],
            form: {
                email: null,
                firstName: null,
                lastName: null,
                id: null,
            }
        }
    },
    computed: {},
    methods: {
        formatedDate(date) {
            return window.moment(date).tz('America/New_York').format('hh:mm A DD MMM YYYY');
        },
        change(event) {
            this.$router.push({ name: 'admin.wallet.wallet_project', params: { page: event } });
            this.getWallets(event);
        },
        getWallets(page) {
            window.axios.get('/admin/wallet/wallet-project/index', {params: {...{page: page}, ...this.form}})
                .then(response => {
                        this.wallets = response.data.wallets;
                        this.paginator.perPage = response.data.per_page;
                        this.paginator.total = response.data.count;
                    }
                );
        },
        search() {
            this.getWallets(this.page);
        }
    },
    mounted() {
        this.getWallets(this.page);
    }
}
</script>